import React from 'react';
import {YearDatePicker, List, Form} from 'components';
import {moment} from 'helpers';
import {matchesRepetition} from 'store/calendar';
import {Repetition} from 'components/activities/single/edit/repetition';
import css from './test.module.scss';

export function TestRepetition() {
  return (
    <main className={css.test}>
      <Form initialValues={{ repetition: initialValues }}>
        { ({ values }) =>
          <div>
            <div style={{ width: '35em' }}>
              <List small-gutter>
                <div>* <b>Weekly</b> option won't work correctly here</div>
                <Repetition allow="onetime, recurring" />
              </List>
            </div>
            <br /><br />
            <YearDatePicker
              minDate={values.repetition.scheduleDate}
              maxDate={values.repetition.endDate}
              dayClassName={date => matchesRepetition(window.store.getState(), { date })(values.repetition) ? 'react-datepicker__day--marked' : ''}
            />
          </div>
        }
      </Form>
    </main>
  )
}

const initialValues = {
  repeatCount: 1,
  repeatCountPerDay: 1,
  repeatDays: '1,2,3,4,5,6,7',
  repeatType: 'PerDay',
  scheduleDate: moment().startOf('day').unix(),
  // endDate: moment().endOf('year').unix(),
  status: 'Not Started',
  ts: null,
}
